export default [
    {
      path: '/admin/sale-contracts',
      name: 'sale-contract',
      meta: { requiresAuth: true },
      component: () => import('@/pages/wholesale/sale-contract/index.vue')
    },
    {
      path: '/admin/sale-contracts/create',
      name: 'sale-contract-create',
      meta: { requiresAuth: true },
      component: () => import('@/pages/wholesale/sale-contract/create.vue')
    },
    {
      path: '/admin/sale-contracts/:id/edit',
      name: 'sale-contract-edit',
      meta: { requiresAuth: true },
      component: () => import('@/pages/wholesale/sale-contract/edit.vue')
    }
  ]
  